export const generatedReleaseEvidenceLedger = {
  "schemaVersion": 1,
  "generatedAt": "2026-06-19T00:00:00.000Z",
  "mode": "deterministic-release-evidence-ledger",
  "operatingRule": "A release may be discussed as a gated beta only when local verification, source evidence, runtime science gates, package review, UI approval, Access approval, CI deploy proof, and alert recovery proof are all explicitly evidenced.",
  "releaseAllowed": false,
  "gateCount": 41,
  "blockedGateCount": 12,
  "statusCounts": {
    "pass": 29,
    "blocked": 6,
    "partial": 2,
    "human-review-pending": 2,
    "external-proof-pending": 2
  },
  "readinessScores": [
    {
      "id": "local-functional-beta",
      "label": "Local functional beta",
      "currentScore": 98,
      "targetScore": 98,
      "gap": 0
    },
    {
      "id": "science-math-credibility",
      "label": "Science/math credibility for beta",
      "currentScore": 96,
      "targetScore": 98,
      "gap": 2
    },
    {
      "id": "ui-review-readiness",
      "label": "UI review readiness",
      "currentScore": 90,
      "targetScore": 98,
      "gap": 8
    },
    {
      "id": "deployment-readiness",
      "label": "Deployment readiness",
      "currentScore": 96,
      "targetScore": 98,
      "gap": 2
    },
    {
      "id": "public-gated-live",
      "label": "Public/gated website live status",
      "currentScore": 96,
      "targetScore": 98,
      "gap": 2
    }
  ],
  "readinessBlockingCount": 4,
  "evidenceHashes": {
    "betaReviewDocket": "sha256-e0c986eb0390db2490b64e5908012bf58f21fd8008f1c54fe84db3775d7123dc",
    "uiFidelityLedger": "sha256-857d823d3c191fe56b18c0fbf5c3c1fdffa61d86ed2ca03009a76bb5113f1e58",
    "uiFidelityApprovalPacket": "sha256-a9ebbc25e00bd64e0c64d0dee15a0a7d2e2241270ff75c11ba09c6c81568bdb6",
    "feasibilityReport": "fnv1a32-5b0df6f9",
    "customerReportPacketLedger": "sha256-dce55147724b8c11e4fd3520a1aa62b076490ea81e6670251dc5111016a8952c",
    "modelArtifactBundle": "sha256-f3b0e534f4e7fb6c252f258ea4c741d6ee42b9bafb479bfb6e680c3c2d48a030",
    "claimEvidenceLedger": "sha256-955a2d2ec1bb591b69b89b51865539cae43207d81051e6ba2e9bbfc696c37770",
    "sourceIngestionLedger": "sha256-0e4319b9702f975d686339d93606beee2b5e4eca89d04e721b2ecf61493690c2",
    "sourcePromotionLedger": "sha256-bace1b5a9aa61005c905a21ed0714a8068faf28be32f08faa09acdf95f9c3fa4",
    "sourceUseRightsLedger": "sha256-d1f63d6a716127db0069f74295cfd720976b3a15e5de3f62b0fe88c8238a6f57",
    "sourceUseReviewPacket": "sha256-510164d326f7598c8543b02a29a8d1aff756b61ea192e1f239b877aace4c6864",
    "sourceUseClearanceDossier": "sha256-bd35dd0b228a9df062050b345e8b1763178982c752bac0b2e0ce6513a7596c18",
    "businessPlatformRoadmap": "sha256-91f63c4f84fdf7f86072fbd70e4d1eae414adae082c6d23f82bdf5563ca749ed",
    "sidecarPromotionLedger": "sha256-ac772d0c153dc9cb61ecb3605e1fd9c8c15eac4fb7e4977ffa014f84d0368ba6",
    "sidecarReadinessLedger": "sha256-7a4b373db0f893ddd30084d8eaffcd2096c429821481b6079022e3e960ffb1c8",
    "runtimeValidationCampaignLedger": "sha256-7d6f913ac6a611baf6052809984397293a597736628121801cff5135edc9a45b",
    "runtimeClosurePacket": "sha256-67b23b0dec664b27b660c3d364a8613c35e7b87b21141f65e88ed7951a57527d",
    "trajectoryValidationMatrix": "sha256-16cd41ff7950bb20d30207308ae8694f4b5cf91faa31f3323bfe10608f7a4e2e",
    "trajectoryResidualAcceptanceLedger": "sha256-9e26a7e1dced7bbea21083bedeece1f325015a72d27f84aa46c763b6e523dcd4",
    "sidecarScaffoldRejectionLedger": "sha256-9e715ab728e73d34a573d04dd6c813c311e0f1979e8bbbdd70f719123c4238e5",
    "sidecarValidationReport": "sha256-aa8df127fd6f74cef0ba42b0ee62827380c4fb8d328808fd77d0793755c90b1f",
    "sidecarWorkOrderPacket": "sha256-8e6bf30aec2a64bb3dfd0d7eaad748c8579454fb6d285b83b557a955c0ace4e4",
    "sidecarRunSpecPacket": "sha256-ce4ff5977802635c5e8c813974453dba222a297a374ab09f9e58d7d61b843d3e",
    "sidecarArtifactTemplatePacket": "sha256-1d12bee590730603b7885e3df87ac787e8ff9b93a104a4227321245507a86d86",
    "asteroidCandidateEvidenceLedger": "sha256-3a4cf27fbcf60e16c76e5d5b2e16490e9dcfe393747d2678474c1f82d234af22",
    "candidateSbdbRefreshManifest": "sha256-c5b0581231f6ca853b76228531f0fa66fe77bf56fcb2d791e809572392a6f3a1",
    "candidateSourceClosurePackets": "sha256-8a53a4e3a8d6fb35dc1e3001ea5958724fd734415b1735163fae5d2ecc543608",
    "candidateSourcePromotionLedger": "sha256-29496b525d4ca2eb53ff80af01f0b474def2f6876ecc381c796afd9a1c68188a",
    "economicsEvidenceLedger": "sha256-676c2d6d270fb909cf21a482178ffcf177df30d095d6c55f918afe08bf6a9297",
    "materialsProcessEvidenceLedger": "sha256-860c27709b9c2e64ffb883271d74cf5b6e44d14c8c8d2c22404f2adda2914f80",
    "scenarioComparisonBoard": "sha256-0e1eace128cfbc59ff9ab66a05bee97e637f3afe3a0990327886d7e717be0c48",
    "scenarioNotebookPack": "sha256-0f0829747839a100054dc1e908300ffa0223fa0e61b8c34a817db361ec67f685",
    "scenarioDecisionLedger": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13",
    "scenarioDecisionAuditLedger": "sha256-866e7246e717b7f2c4f1f2b6a0be137698a79cf20280f3781e780e8d959cca00",
    "scenarioCrossoverFrontier": "sha256-59e7ad43803aeedff01de819f78f249c076874a2ee34fe49e07030417db953f1",
    "scenarioDecisionDeltaLedger": "sha256-f4a173a8bcceded9b5233a16c6183b796691655ee8eb0a41db4532211e6115de",
    "scenarioDiligenceWorkOrderLedger": "sha256-077fc3aa81c911ed7d1383a077ee114465590356ac05749cae6233010c44f92a",
    "scenarioTraceabilityMatrix": "sha256-7623fbca52cfe5d3f3bc9d38df0be662a82c990b2776c01d7da3521756eff5a6",
    "evidenceGapPriorityLedger": "sha256-0d96cc2ff9254f569ef8adbc51ba340f18dd55f15b5a02ce9adecdc6291e17a7",
    "promotionClosureLedger": "sha256-d14fdc5117888b18cc4aaf6eabc8c09785595638de06e3cabcdd8cc0f8421f1c",
    "capabilityMaturityLedger": "sha256-f1dc7ec56ccebef2ce81f203d8973948478d7129005c65ef75c9cca15366defd",
    "modelValidationProtocols": "sha256-6aa23a5aebbeb63c2692898e189c7abcb422184f0a56de8653ae262f9b1f1db2",
    "workspaceLedger": "sha256-06be4865541ea0844d8c870d423cee2f284e13b32cb3ae611d3f3d4278940755",
    "researchPackageManifest": "sha256-acb877a48f3c3f16951cd0ffc3244b627c4fce0084e6eff9ca8a11a0fc37b9fb",
    "customerReadinessContracts": "sha256-a712bbce926ca0e0de3d0b50bbbe6d84fc387c80b02b51df8a68f41cb3f9633a"
  },
  "gates": [
    {
      "id": "local-verification-suite",
      "label": "Local verification suite",
      "owner": "Product engineering",
      "status": "pass",
      "evidence": {
        "verifyScript": "npm run science:report && npm test && npm run readiness && npm run test:browser",
        "expectedCommands": [
          "npm run science:report",
          "npm test",
          "npm run readiness",
          "npm run test:browser"
        ]
      },
      "requiredProof": "A current `npm run verify` receipt with tests, readiness, build, and browser regression passing.",
      "nextAction": "Keep `npm run verify` green before any release or deployment claim.",
      "blocker": null,
      "gateHash": "sha256-65bf1d46bbd41afe4dcf369f91cc7bedbdac730d57588af38d01bba0b5c11d07"
    },
    {
      "id": "science-artifact-bundle",
      "label": "Science artifact bundle",
      "owner": "Science kernel",
      "status": "pass",
      "evidence": {
        "bundleHash": "sha256-f3b0e534f4e7fb6c252f258ea4c741d6ee42b9bafb479bfb6e680c3c2d48a030",
        "artifactCount": 7,
        "blockedArtifactCount": 7
      },
      "requiredProof": "Every model artifact is hash-backed and remains blocked unless source/runtime gates pass.",
      "nextAction": "Do not promote model outputs until runtime and source intake gates pass.",
      "blocker": null,
      "gateHash": "sha256-d1e4714fb5a55429398b42957942f49325919f7fe0fc387180a18e8acbb87d92"
    },
    {
      "id": "model-run-comparisons",
      "label": "Model-run comparison ledger",
      "owner": "Scenario engine",
      "status": "pass",
      "evidence": {
        "ledgerHash": "sha256-1e7530f030dd80804d867901fd6c5f504f4d4ac5125ee82a2f6484dd0d6ae23d",
        "modelRunLedgerHash": "sha256-23bb534c7980aa6ab7ba79b91f0d489e8f13deb5ed8999f3170c0c78030563c2",
        "comparisonCount": 2,
        "selectedScenarioChangeCount": 2,
        "rankOneChangeCount": 0,
        "commercialUseAllowed": false
      },
      "requiredProof": "Every changed scenario conclusion has a hash-backed comparison against the baseline run with rank, utility, uncertainty, business-case, and replay-boundary deltas.",
      "nextAction": "Use model-run comparisons in customer packages before claiming a recommendation changed or remained stable.",
      "blocker": null,
      "gateHash": "sha256-c5170185803bda44dc54f5734063850aa3afff40da84a63916906842a6a7a7f0"
    },
    {
      "id": "customer-decision-dossiers",
      "label": "Customer decision dossier ledger",
      "owner": "Product/research packaging",
      "status": "pass",
      "evidence": {
        "ledgerHash": "sha256-fe0cb326f94ee79eb42dbe94b45e2166cc90cd1c6efc4d32ac0065292d74b669",
        "scenarioDecisionLedgerHash": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13",
        "scenarioCount": 6,
        "paidBetaDossierCount": 1,
        "blockedDossierCount": 6,
        "commercialUseAllowed": false,
        "customerUseAllowed": false
      },
      "requiredProof": "Every scenario has a hash-backed customer decision dossier that states allowed use, blockers, proof-to-change-answer, and next proof actions.",
      "nextAction": "Use dossiers as the customer-facing review layer for packages, but keep customer/commercial use blocked until source-use, runtime, economics, resource, UI, and release gates close.",
      "blocker": null,
      "gateHash": "sha256-eb2d27ff59781d98caa676cdeab2bb6120701c214d3ac35eae55d714f4bf3f69"
    },
    {
      "id": "scenario-diligence-work-orders",
      "label": "Scenario diligence work orders",
      "owner": "Product/research operations",
      "status": "pass",
      "evidence": {
        "ledgerHash": "sha256-077fc3aa81c911ed7d1383a077ee114465590356ac05749cae6233010c44f92a",
        "workOrderCount": 12,
        "experimentBacklogCount": 12,
        "p0WorkOrderCount": 3,
        "coveredP0GapCount": 3,
        "p0GapCount": 3,
        "customerUseAllowed": false,
        "commercialUseAllowed": false
      },
      "requiredProof": "Every evidence-gap experiment has a hash-backed diligence work order with customer question, affected packages, acceptance gates, replay command, and decision-delta contract.",
      "nextAction": "Execute P0 work orders first, then attach reviewed source/runtime artifacts before rerunning scenario decisions and customer dossiers.",
      "blocker": null,
      "gateHash": "sha256-fc43505545df61584da039fbac7da2c3779a2e8c0255ca19f3ba7369f515bf1c"
    },
    {
      "id": "scenario-decision-delta-acceptance",
      "label": "Scenario decision delta acceptance",
      "owner": "Product/research operations",
      "status": "pass",
      "evidence": {
        "ledgerHash": "sha256-f4a173a8bcceded9b5233a16c6183b796691655ee8eb0a41db4532211e6115de",
        "scenarioDiligenceWorkOrderLedgerHash": "sha256-077fc3aa81c911ed7d1383a077ee114465590356ac05749cae6233010c44f92a",
        "deltaRecordCount": 12,
        "blockedDeltaRecordCount": 12,
        "acceptedDeltaRecordCount": 0,
        "materialChangeDetectedCount": 0,
        "customerUseAllowed": false,
        "commercialUseAllowed": false
      },
      "requiredProof": "Every diligence work order has a fail-closed before/after delta acceptance record requiring an after-run artifact before a customer-facing scenario answer can change.",
      "nextAction": "Attach after-run delta artifacts only after source/runtime/economics/material/resource proof gates pass and reviewer approval is captured.",
      "blocker": null,
      "gateHash": "sha256-43f40cda77b4234b1011065e5b782dc34d1ba86a9c35bbd0b461431b030ce9bc"
    },
    {
      "id": "scenario-comparison-board",
      "label": "Scenario comparison board exports",
      "owner": "Product/science kernel",
      "status": "pass",
      "evidence": {
        "boardHash": "sha256-0e1eace128cfbc59ff9ab66a05bee97e637f3afe3a0990327886d7e717be0c48",
        "scenarioCount": 6,
        "selectedScenarioId": "moon-first",
        "csvHash": "sha256-cecffa188f8d5bbebd2d9bbb154686387cfd2b9fc9456c87f5de2e54eab02266",
        "markdownHash": "sha256-868546f68bf68e815c22bc7742b29083171535c4c9226004e682eb5583180b02",
        "commercialUseAllowed": false
      },
      "requiredProof": "Every scenario comparison row has a decision, uncertainty, economics, traceability, crossover, CSV, and Markdown export hash before reviewer/customer package use.",
      "nextAction": "Use comparison exports for internal review and paid-beta scoping only until runtime, source-use, economics, resource, UI, and reviewer gates pass.",
      "blocker": null,
      "gateHash": "sha256-5f388c3f9720ae4900af684ddca60c405391952406563a225f98e6a0bdb3a6a4"
    },
    {
      "id": "scenario-notebook-pack",
      "label": "Scenario notebook pack",
      "owner": "Product/research packaging",
      "status": "pass",
      "evidence": {
        "packHash": "sha256-0f0829747839a100054dc1e908300ffa0223fa0e61b8c34a817db361ec67f685",
        "notebookCount": 6,
        "sourceDefinedNotebookCount": 3,
        "generatedCoverageGapNotebookCount": 3,
        "customerUseAllowed": false,
        "commercialUseAllowed": false
      },
      "requiredProof": "Every scenario has a hash-backed reviewer notebook with markdown export, explicit source coverage, open questions, blockers, and fail-closed customer/commercial use flags.",
      "nextAction": "Replace generated coverage-gap notebooks with reviewer-authored, source-backed notebooks before customer delivery.",
      "blocker": null,
      "gateHash": "sha256-dc48d47d428b7d812d9d3025317203b0010974984443604cd16c1988636a19a0"
    },
    {
      "id": "customer-report-packets",
      "label": "Customer report packets",
      "owner": "Product/research packaging",
      "status": "pass",
      "evidence": {
        "ledgerHash": "sha256-dce55147724b8c11e4fd3520a1aa62b076490ea81e6670251dc5111016a8952c",
        "researchPackageManifestHash": "sha256-acb877a48f3c3f16951cd0ffc3244b627c4fce0084e6eff9ca8a11a0fc37b9fb",
        "reportPacketCount": 3,
        "blockedReportPacketCount": 3,
        "customerReadyReportPacketCount": 0,
        "reportExportCount": 3,
        "blockedReportExportCount": 3,
        "customerUseAllowed": false,
        "commercialUseAllowed": false
      },
      "requiredProof": "Every research package has a hash-backed customer report packet and Markdown review export with executive answer, evidence appendix, proof gates, export contract, and blocked delivery boundary.",
      "nextAction": "Use report packets for internal review and paid-beta scoping only until all source-use, runtime, economics, materials, resource, workspace, UI, and reviewer gates pass.",
      "blocker": null,
      "gateHash": "sha256-7c05583ee1803b5ae1ae81791fe12caccdd3bdd1825f4d97f0b1d6c02709f608"
    },
    {
      "id": "beta-review-docket",
      "label": "Beta review docket",
      "owner": "Release governance",
      "status": "pass",
      "evidence": {
        "docketHash": "sha256-e0c986eb0390db2490b64e5908012bf58f21fd8008f1c54fe84db3775d7123dc",
        "approvalSlotCount": 7,
        "blockedSlotCount": 7,
        "approvedSlotCount": 0,
        "releaseApprovalAllowed": false,
        "markdownHash": "sha256-142ac7820bf527022ca8d9232d80bf8834222c3eb3add92818d5333af335764c"
      },
      "requiredProof": "Every required human/external approval has an owner, required proof, linked artifact hashes, and a fail-closed signoff state.",
      "nextAction": "Use the docket to collect owner UI, source-use, runtime science, customer delivery, workspace, alert, and release-manager approvals without treating the docket itself as approval.",
      "blocker": null,
      "gateHash": "sha256-47a4da5ce7a49b5576640e897e1dfac045c93a25ad8f40f57e8d87cd4d1b10d7"
    },
    {
      "id": "source-ingestion-contracts",
      "label": "Source ingestion contracts",
      "owner": "Source registry",
      "status": "pass",
      "evidence": {
        "ledgerHash": "sha256-0e4319b9702f975d686339d93606beee2b5e4eca89d04e721b2ecf61493690c2",
        "sourceCount": 33,
        "workOrderCount": 33,
        "domainCount": 8,
        "genericSourceCount": 0
      },
      "requiredProof": "Every source registry record has a classified source ingestion work order.",
      "nextAction": "Capture reviewed source payload artifacts through `npm run science:source:intake`.",
      "blocker": null,
      "gateHash": "sha256-cfeedcc4c22a22d3e2b81ec49c41f1d20aaccd72fc1c5328a71941d633a34452"
    },
    {
      "id": "source-payload-promotion",
      "label": "Reviewed source payload promotion",
      "owner": "Science/source review",
      "status": "pass",
      "evidence": {
        "sourceIngestionLedgerHash": "sha256-0e4319b9702f975d686339d93606beee2b5e4eca89d04e721b2ecf61493690c2",
        "sourcePromotionLedgerHash": "sha256-bace1b5a9aa61005c905a21ed0714a8068faf28be32f08faa09acdf95f9c3fa4",
        "blockedWorkOrderCount": 33,
        "reportCount": 1,
        "promotedCount": 17,
        "p0PromotionGapCount": 0,
        "promotionState": "source-promotion-ready-for-review",
        "intakeCommand": "node scripts/validate-source-ingestion-intake.mjs"
      },
      "requiredProof": "A reviewed source payload intake report with promotedCount > 0 for each source needed by promoted claims.",
      "nextAction": "Run `npm run science:source:intake -- <payload.json>` on reviewed Horizons/SBDB/CAD/PDS/NIST/etc. payloads.",
      "blocker": "",
      "gateHash": "sha256-730ef32f2b5507d10209f5f024d679aa380a10606b4c342b6b4df7f9b077d0e4"
    },
    {
      "id": "source-use-rights-review",
      "label": "Source use-rights review",
      "owner": "Source/legal review",
      "status": "blocked",
      "evidence": {
        "ledgerHash": "sha256-d1f63d6a716127db0069f74295cfd720976b3a15e5de3f62b0fe88c8238a6f57",
        "sourceCount": 33,
        "blockedSourceUseCount": 33,
        "rawRedistributionAllowed": false,
        "customerUseAllowed": false,
        "highRiskCount": 2
      },
      "requiredProof": "Every source used in customer-facing reports has captured terms/license evidence, citation policy, redistribution decision, and reviewer approval.",
      "nextAction": "Capture source-specific terms/license artifacts and reviewer approvals before customer/commercial use.",
      "blocker": "Source-use rights remain blocked for customer/commercial use and raw payload redistribution.",
      "gateHash": "sha256-7c83e8fa02c13925fc2e98d96f886753165eca42ded5e81f6512403559d42c26"
    },
    {
      "id": "source-use-review-packets",
      "label": "Source use review packets",
      "owner": "Source/legal review",
      "status": "pass",
      "evidence": {
        "packetHash": "sha256-510164d326f7598c8543b02a29a8d1aff756b61ea192e1f239b877aace4c6864",
        "sourceUseRightsLedgerHash": "sha256-d1f63d6a716127db0069f74295cfd720976b3a15e5de3f62b0fe88c8238a6f57",
        "packetCount": 33,
        "blockedPacketCount": 33,
        "customerUseAllowed": false,
        "rawRedistributionAllowed": false,
        "p0ReviewPacketCount": 2
      },
      "requiredProof": "Every source-use rights record has a deterministic review packet with terms, citation, redistribution, provider-boundary, and customer-use decisions listed.",
      "nextAction": "Use the packet queue to capture terms/license evidence and reviewer approvals; do not treat packet generation as legal clearance.",
      "blocker": null,
      "gateHash": "sha256-d06d0fe1bd83f6e4376ffc62d6a2d1c21eb1dd0e0a4d66af26105270a540e304"
    },
    {
      "id": "source-use-clearance-dossier",
      "label": "Source use clearance dossier",
      "owner": "Source/legal review",
      "status": "pass",
      "evidence": {
        "dossierHash": "sha256-bd35dd0b228a9df062050b345e8b1763178982c752bac0b2e0ce6513a7596c18",
        "sourceUseRightsLedgerHash": "sha256-d1f63d6a716127db0069f74295cfd720976b3a15e5de3f62b0fe88c8238a6f57",
        "sourceUseReviewPacketHash": "sha256-510164d326f7598c8543b02a29a8d1aff756b61ea192e1f239b877aace4c6864",
        "sourceCount": 33,
        "blockedSourceCount": 33,
        "classCount": 5,
        "decisionStateCounts": {
          "internal-research-only": 5
        },
        "customerUseAllowed": false,
        "rawRedistributionAllowed": false,
        "markdownHash": "sha256-a4b3363a0dceb88d57589cbe5bb0d252eedad46af18c3fa8873fd54be226382e"
      },
      "requiredProof": "Every source-use class has a fail-closed clearance dossier row with required approvals, redistribution boundary, customer-use decision, and top source packets.",
      "nextAction": "Use the dossier to close P0 commercial/public-source and P1 standards/tool review before customer-facing package delivery.",
      "blocker": null,
      "gateHash": "sha256-b63ddbea76836968b95658b0c4d723d8d857ebb85ea60a4eeaf6b3b929f15c82"
    },
    {
      "id": "business-platform-roadmap",
      "label": "Business platform roadmap",
      "owner": "Product strategy",
      "status": "pass",
      "evidence": {
        "roadmapHash": "sha256-91f63c4f84fdf7f86072fbd70e4d1eae414adae082c6d23f82bdf5563ca749ed",
        "sourceReferenceCount": 14,
        "capabilityCount": 6,
        "phaseCount": 6,
        "blockedCapabilityCount": 6,
        "customerUseAllowed": false,
        "commercialUseAllowed": false,
        "markdownHash": "sha256-878f85ba99cd7c415663d87a34511991212e56ba48d39def1fef4db5514702ce"
      },
      "requiredProof": "The long-term product roadmap is a hash-backed, source-referenced, fail-closed capability plan tied to current evidence ledgers, customer value, blockers, and proof gates.",
      "nextAction": "Use the roadmap to prioritize implementation sprints without claiming customer/commercial readiness until the linked blockers close.",
      "blocker": null,
      "gateHash": "sha256-2c94ecece2541c83d91917cf98e474fa5bac551a6fa6bf0f56ad895170bff8de"
    },
    {
      "id": "runtime-sidecar-contracts",
      "label": "Runtime sidecar contracts",
      "owner": "Science compute",
      "status": "pass",
      "evidence": {
        "packetHash": "sha256-8e6bf30aec2a64bb3dfd0d7eaad748c8579454fb6d285b83b557a955c0ace4e4",
        "runSpecPacketHash": "sha256-ce4ff5977802635c5e8c813974453dba222a297a374ab09f9e58d7d61b843d3e",
        "artifactTemplatePacketHash": "sha256-1d12bee590730603b7885e3df87ac787e8ff9b93a104a4227321245507a86d86",
        "workOrderCount": 5,
        "runSpecCount": 5,
        "artifactTemplateCount": 5,
        "validationReportHash": "sha256-aa8df127fd6f74cef0ba42b0ee62827380c4fb8d328808fd77d0793755c90b1f",
        "contractCount": 5
      },
      "requiredProof": "Every runtime sidecar contract has a work order, run specification, artifact template, and validation gate.",
      "nextAction": "Generate real SPICE/Orekit/GMAT/Tudat/OpenMDAO artifacts and run `npm run science:sidecar:intake`.",
      "blocker": null,
      "gateHash": "sha256-cf65a88a6f2a6f8db40317c143e4d322171d4d2ee47f949b4ef8db5e5fbdbdc7"
    },
    {
      "id": "runtime-sidecar-promotion",
      "label": "Runtime sidecar promotion",
      "owner": "Science compute",
      "status": "partial",
      "evidence": {
        "promotedCount": 3,
        "promotedContractCount": 2,
        "blockedCount": 3,
        "reportCount": 3,
        "promotionState": "partial-runtime-promotion-contract-gaps",
        "sidecarPromotionLedgerHash": "sha256-ac772d0c153dc9cb61ecb3605e1fd9c8c15eac4fb7e4977ffa014f84d0368ba6",
        "validationReportHash": "sha256-aa8df127fd6f74cef0ba42b0ee62827380c4fb8d328808fd77d0793755c90b1f"
      },
      "requiredProof": "At least one runtime sidecar artifact promotes through the sidecar intake validation gate.",
      "nextAction": "Start with SPICE GF event windows or Orekit propagation, then cross-check with GMAT/Tudat.",
      "blocker": "3 sidecar contract(s) still lack promoted runtime artifacts.",
      "gateHash": "sha256-6aa27a906a7eee620ec927e44047d1950315ae88ab586a97c09ba1f8b9105088"
    },
    {
      "id": "runtime-sidecar-readiness-ledger",
      "label": "Runtime sidecar readiness ledger",
      "owner": "Science compute",
      "status": "pass",
      "evidence": {
        "ledgerHash": "sha256-7a4b373db0f893ddd30084d8eaffcd2096c429821481b6079022e3e960ffb1c8",
        "promotedRuntimeContractCount": 2,
        "readyToRunContractCount": 0,
        "blockedRuntimeContractCount": 3,
        "sidecarPromotionLedgerHash": "sha256-ac772d0c153dc9cb61ecb3605e1fd9c8c15eac4fb7e4977ffa014f84d0368ba6"
      },
      "requiredProof": "Every sidecar contract has a readiness row separating promoted runtime evidence, ready-to-run preflight state, blocked prerequisites, and next action.",
      "nextAction": "Use this ledger to schedule Orekit/GMAT/Tudat runtime closure without treating preflight as science evidence.",
      "blocker": null,
      "gateHash": "sha256-f41ca7338775c19d65395e574dea6f845c94aab0c2d7d15c7d44d5a47b4c3ef6"
    },
    {
      "id": "runtime-validation-campaigns",
      "label": "Runtime validation campaigns",
      "owner": "Science compute",
      "status": "pass",
      "evidence": {
        "ledgerHash": "sha256-7d6f913ac6a611baf6052809984397293a597736628121801cff5135edc9a45b",
        "campaignCount": 6,
        "blockedCampaignCount": 4,
        "statusCounts": {
          "runtime-promoted-currently-reproducible": 2,
          "blocked-runtime-prerequisites": 4
        },
        "markdownHash": "sha256-78ebc5b25ce76517cfa83cb3360483ef3ed27d74de470d512389b234981cb2ea",
        "customerUseAllowed": false,
        "commercialUseAllowed": false
      },
      "requiredProof": "Every runtime validation campaign has exact contract ids, commands, output paths, scenario refs, blockers, and acceptance rules before runtime closure work starts.",
      "nextAction": "Execute P0 runtime campaigns in order: current SPICE reproducibility, Orekit, GMAT, Tudat, then cross-tool residual frontier.",
      "blocker": null,
      "gateHash": "sha256-9fbfdf05a43ac42a6ea380a3c3c0f3668ca12cac46c1ba4eacb51049d9d4a506"
    },
    {
      "id": "runtime-closure-packet",
      "label": "Runtime closure packet",
      "owner": "Science compute",
      "status": "pass",
      "evidence": {
        "packetHash": "sha256-67b23b0dec664b27b660c3d364a8613c35e7b87b21141f65e88ed7951a57527d",
        "contractCount": 5,
        "campaignCount": 6,
        "closureStateCounts": {
          "closed-currently-reproducible": 2,
          "blocked-before-runtime-generation": 3
        },
        "blockerClassCounts": {
          "build-artifact": 1,
          "input-custody": 1,
          "system-runtime": 1,
          "external-application": 1,
          "python-package": 1
        },
        "markdownHash": "sha256-5fa4c71ca1f597211c06e690f5142378e81be03e6eff2683d8dfea7d70df8bec",
        "customerUseAllowed": false,
        "commercialUseAllowed": false
      },
      "requiredProof": "Every runtime sidecar contract has a closure record with setup custody, commands, output path, intake report path, campaign refs, blockers, and acceptance checklist.",
      "nextAction": "Use the packet as the operator runbook for Java/Orekit, GMAT, TudatPy, SPICE, and OpenMDAO runtime closure; do not treat it as science evidence.",
      "blocker": null,
      "gateHash": "sha256-1a22bf9a56056ad970b3e273c2c1ded3e24d7de03d410548fb764e6426824319"
    },
    {
      "id": "trajectory-validation-matrix",
      "label": "Trajectory validation matrix",
      "owner": "Science compute",
      "status": "pass",
      "evidence": {
        "matrixHash": "sha256-16cd41ff7950bb20d30207308ae8694f4b5cf91faa31f3323bfe10608f7a4e2e",
        "rowCount": 4,
        "blockedRowCount": 4,
        "crossToolResidualFrontierState": "blocked-until-orekit-gmat-tudat-runtime-artifacts-promote",
        "markdownHash": "sha256-886b8b73bb331ff3b806b271bd17f75dda3a13b9c122da31a83fae15c66ca65f",
        "customerUseAllowed": false,
        "commercialUseAllowed": false
      },
      "requiredProof": "SPICE/Orekit/GMAT/Tudat rows must show current runtime evidence state, independent-comparison blockers, scenario decision links, and fail-closed customer-use boundaries.",
      "nextAction": "Generate Orekit, GMAT, and Tudat runtime artifacts, pass intake validation, attach scenario decision deltas, then rerun the matrix before any trajectory-based ranking change.",
      "blocker": null,
      "gateHash": "sha256-e3434654040b9b15ebde4e8e35f759eb2862c5c751397c78c44c2872d428d552"
    },
    {
      "id": "trajectory-residual-acceptance-ledger",
      "label": "Trajectory residual acceptance ledger",
      "owner": "Science/runtime validation",
      "status": "pass",
      "evidence": {
        "ledgerHash": "sha256-9e26a7e1dced7bbea21083bedeece1f325015a72d27f84aa46c763b6e523dcd4",
        "residualAcceptanceCount": 4,
        "blockedResidualAcceptanceCount": 4,
        "trajectoryValidationMatrixHash": "sha256-16cd41ff7950bb20d30207308ae8694f4b5cf91faa31f3323bfe10608f7a4e2e",
        "markdownHash": "sha256-9eb691413e9b667e6934b06a7dba4951af9a017d57998782f27adc7cc390a35f",
        "decisionUseAllowed": false,
        "customerUseAllowed": false,
        "commercialUseAllowed": false
      },
      "requiredProof": "Every trajectory comparison lane has runtime artifact refs, residual dimensions, decision-delta requirements, blockers, and hash-backed acceptance records.",
      "nextAction": "Generate Orekit/GMAT/Tudat runtime artifacts, promote them through sidecar intake, and attach accepted before/after scenario decision deltas before changing scenario rankings.",
      "blocker": "Residual acceptance lanes are defined but blocked until runtime artifacts and decision deltas pass.",
      "gateHash": "sha256-7f69d28149365cbdcf92c5f5c64fb0fa766dc1c7f2d12b24696067a0fb492d19"
    },
    {
      "id": "runtime-sidecar-scaffold-rejections",
      "label": "Runtime sidecar scaffold rejection ledger",
      "owner": "Science compute",
      "status": "pass",
      "evidence": {
        "ledgerHash": "sha256-9e715ab728e73d34a573d04dd6c813c311e0f1979e8bbbdd70f719123c4238e5",
        "scaffoldCount": 3,
        "rejectedScaffoldCount": 3,
        "unexpectedPromotionCount": 0,
        "rejectedContractIds": [
          "orekit-propagation-v1",
          "gmat-transfer-v1",
          "tudat-transfer-v1"
        ]
      },
      "requiredProof": "Orekit, GMAT, and Tudat beta scaffolds are contract-traceable and fail promotion through the sidecar intake logic.",
      "nextAction": "Replace each scaffold with a reviewed runtime artifact only after the runtime worker produces hashes, units, uncertainty, and independent-comparison evidence.",
      "blocker": null,
      "gateHash": "sha256-3bd34d95e0bbc8bf537d62f6fed9026adf32e06c80950c43f4d1f40dd5c922fb"
    },
    {
      "id": "scenario-decision-audits",
      "label": "Scenario decision audits",
      "owner": "Product/science review",
      "status": "pass",
      "evidence": {
        "ledgerHash": "sha256-866e7246e717b7f2c4f1f2b6a0be137698a79cf20280f3781e780e8d959cca00",
        "auditCount": 6,
        "scenarioCount": 6,
        "leaderScenarioId": "moon-first",
        "commercialUseAllowed": false
      },
      "requiredProof": "Every scenario decision has an audit row with explanation, flip condition, sensitive assumptions, validation refs, and proof burden.",
      "nextAction": "Keep decision audits synchronized with scenario decisions before any package or report export.",
      "blocker": null,
      "gateHash": "sha256-023f96a98952908cc86c32c8831db136caadbaff8e3511fe2fa128fab9c10a69"
    },
    {
      "id": "scenario-crossover-frontiers",
      "label": "Scenario crossover frontiers",
      "owner": "Scenario engine",
      "status": "pass",
      "evidence": {
        "ledgerHash": "sha256-59e7ad43803aeedff01de819f78f249c076874a2ee34fe49e07030417db953f1",
        "leaderScenarioId": "moon-first",
        "challengerCount": 5,
        "pairwiseComparisonCount": 30,
        "nearestCrossoverScenarioId": "hybrid",
        "commercialUseAllowed": false
      },
      "requiredProof": "Every challenger scenario has a hash-backed crossover row showing utility gap, assumption levers, feasibility boundary, and evidence boundary.",
      "nextAction": "Keep crossover frontiers synchronized with scenario rankings and use them only as decision-support heuristics.",
      "blocker": null,
      "gateHash": "sha256-b34c0ca41a2b54e97029eaf2c041a2df114772009e1ef5a19ab6c1114dd8e9a6"
    },
    {
      "id": "scenario-uncertainty-budgets",
      "label": "Scenario uncertainty budgets",
      "owner": "Scenario engine",
      "status": "pass",
      "evidence": {
        "ledgerHash": "sha256-bc5d03c9507915ce3a6f2edfaf280eb7198445b0f5c015397a1893ba27342596",
        "scenarioCount": 6,
        "highestUncertaintyScenarioId": "mercury-orbit",
        "highestUncertaintyBudgetPoints": 65.61,
        "categoryTotals": {
          "model-spread": 77.36,
          "runtime-sidecar": 61,
          "assumption-sensitivity": 58,
          "source-use-rights": 36.78,
          "economics-evidence": 20.32,
          "resource-evidence": 42.1,
          "driver-volatility": 15.76
        },
        "commercialUseAllowed": false,
        "promotionAllowed": false
      },
      "requiredProof": "Every scenario has a hash-backed uncertainty budget decomposing modeled spread, assumptions, runtime, source-use, economics, and resource uncertainty.",
      "nextAction": "Use the budget reduction sequence to prioritize runtime sidecars, source-use review, economics normalization, and resource evidence capture.",
      "blocker": null,
      "gateHash": "sha256-4355e6e2d03acd327da244456e07d9c42ec60290e97cad573d5c3c1d3e180b90"
    },
    {
      "id": "model-validation-protocols",
      "label": "Model validation protocols",
      "owner": "Science/product governance",
      "status": "partial",
      "evidence": {
        "ledgerHash": "sha256-6aa23a5aebbeb63c2692898e189c7abcb422184f0a56de8653ae262f9b1f1db2",
        "protocolCount": 9,
        "blockedProtocolCount": 9,
        "stateCounts": {
          "beta-reviewable-non-commercial": 2,
          "blocked-validation-gaps": 7
        }
      },
      "requiredProof": "Every model domain has acceptance criteria, required source/runtime gates, test vectors, and commercial-use state.",
      "nextAction": "Resolve model-validation protocol blockers by promoting required source payloads and runtime sidecar artifacts.",
      "blocker": "Ephemeris geometry and contact/event-window validation: Capability blocker: Runtime sidecar validation blocked: spice-gf-event-window-v1 Small-body orbit, close-approach, and resource-candidate validation: Runtime sidecar artifact not promoted: orekit-propagation-v1 Trajectory, transfer, and logistics cross-tool validation: Runtime sidecar artifact not promoted: orekit-propagation-v1",
      "gateHash": "sha256-ea0c0f9e7a5a5a2fd80c4884183ab73503bf3a387b284af323e7ea2d059bdb58"
    },
    {
      "id": "scenario-traceability",
      "label": "Scenario traceability matrix",
      "owner": "Product/science review",
      "status": "pass",
      "evidence": {
        "matrixHash": "sha256-7623fbca52cfe5d3f3bc9d38df0be662a82c990b2776c01d7da3521756eff5a6",
        "scenarioCount": 6,
        "blockedTraceCount": 6,
        "promotionAllowed": false,
        "scenarioDecisionLedgerHash": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13"
      },
      "requiredProof": "Every scenario decision has a trace row linking ranking, assumptions, claims, sources, runs, runtime sidecars, and blockers.",
      "nextAction": "Keep traces fail-closed until source, sidecar, economics, resource, and review gates promote.",
      "blocker": null,
      "gateHash": "sha256-21e7992d832b2eda9570aab176ccb2ba3a9a9766be40602c5700f9c461842621"
    },
    {
      "id": "candidate-sbdb-refresh-manifest",
      "label": "Candidate SBDB refresh manifest",
      "owner": "Science/source custody",
      "status": "pass",
      "evidence": {
        "manifestHash": "sha256-c5b0581231f6ca853b76228531f0fa66fe77bf56fcb2d791e809572392a6f3a1",
        "sourceCaptureHash": "sha256-2ad162480cc48a0874105a289f1df9732e325c92f043f7f9d1ba379bb8f37d98",
        "workOrderCount": 10,
        "cadRecordCount": 10,
        "sbdbRecordCount": 10,
        "missingSbdbCount": 0,
        "readyDraftCount": 10,
        "allWorkOrdersHaveCad": true,
        "allWorkOrdersHaveSbdb": true,
        "sourceCustodyPromotionAllowed": false,
        "resourcePromotionAllowed": false,
        "customerUseAllowed": false,
        "recommendedRefreshCommand": "npm run science:smallbody:capture -- --limit 10 --sbdb-limit 10 --out evidence/source-candidate-payloads/small-body-live-capture-current.json"
      },
      "requiredProof": "Every CAD-screened candidate work order has a deterministic SBDB refresh state, expected payload/report path, query URL, and hash-backed refresh item before source-custody review.",
      "nextAction": "Run the recommended SBDB refresh command, regenerate work-order drafts, and preserve promotion boundaries until MPC, reviewer, source-use, and composition evidence pass.",
      "blocker": null,
      "gateHash": "sha256-0cf59932553603bb28a8eda545245000be91b1e4e91ece2c3119449880207a97"
    },
    {
      "id": "resource-candidate-promotion",
      "label": "Resource candidate promotion",
      "owner": "Resource ledger",
      "status": "blocked",
      "evidence": {
        "ledgerHash": "sha256-3a4cf27fbcf60e16c76e5d5b2e16490e9dcfe393747d2678474c1f82d234af22",
        "candidateSourcePromotionLedgerHash": "sha256-29496b525d4ca2eb53ff80af01f0b474def2f6876ecc381c796afd9a1c68188a",
        "candidateSourceClosurePacketHash": "sha256-8a53a4e3a8d6fb35dc1e3001ea5958724fd734415b1735163fae5d2ecc543608",
        "candidateCount": 3,
        "blockedCandidateCount": 3,
        "sourceCandidateLedgerHash": "sha256-ee609d008f0470c727ad738d35e9787a186b9e6c3d1fc92f4e37b74e2e1b28cd",
        "geometryCandidateCount": 10,
        "sourceCandidatePayloadState": "live-capture-review-candidate",
        "sourceCandidateResourcePromotionAllowed": false,
        "candidateSourcePromotionState": "blocked-no-candidate-source-custody",
        "candidateSourceCustodyPromotionAllowed": false,
        "candidateSourceResourcePromotionAllowed": false,
        "candidateSourceCustomerUseAllowed": false,
        "candidateSourceWorkOrderGapCount": 10,
        "candidateSourceClosurePacketCount": 10,
        "candidateSourceClosureSourceCustodyBlockedCount": 10,
        "candidateSourceClosureResourceBlockedCount": 10,
        "candidateSourceClosureCustomerBlockedCount": 10
      },
      "requiredProof": "Candidate-specific SBDB/CAD/MPC/taxonomy/spectra/mission evidence, reviewed source custody, and customer-use clearance exist for promoted resource claims.",
      "nextAction": "Promote candidate-specific source work-order intake reports, then attach taxonomy/spectra/mission evidence and source-use clearance before resource promotion.",
      "blocker": "Asteroid candidates have geometry-screen evidence only; candidate source custody, resource composition, and customer-use gates remain blocked.",
      "gateHash": "sha256-c5f5de33dcd3d07c91c1455771309a8a507a4c2331f15f51a34d1257c42fa014"
    },
    {
      "id": "economics-promotion",
      "label": "Economics promotion",
      "owner": "Business modeling",
      "status": "blocked",
      "evidence": {
        "ledgerHash": "sha256-676c2d6d270fb909cf21a482178ffcf177df30d095d6c55f918afe08bf6a9297",
        "recordCount": 5,
        "blockedRecordCount": 5
      },
      "requiredProof": "Dated, normalized cost and economics source payloads are model-ready.",
      "nextAction": "Promote dated launch, delivery, capex, opex, market, and award records through source intake.",
      "blocker": "Economics records are still blocked from commercial economics claims.",
      "gateHash": "sha256-f1eafc986846fd7177bc48108c23465badb3a0649f22a041eccdb4ea49c7bdec"
    },
    {
      "id": "materials-process-promotion",
      "label": "Materials/process promotion",
      "owner": "Manufacturing science",
      "status": "blocked",
      "evidence": {
        "ledgerHash": "sha256-860c27709b9c2e64ffb883271d74cf5b6e44d14c8c8d2c22404f2adda2914f80",
        "processCount": 3,
        "blockedProcessCount": 3,
        "topProcessGapId": "spf-db"
      },
      "requiredProof": "Process-specific material property payloads and Cantera/MOOSE/OpenFOAM or equivalent runtime artifacts are promoted.",
      "nextAction": "Promote reviewed NIST/Materials Project/PDS material records and runtime process artifacts before using process claims commercially.",
      "blocker": "Materials/process records are still blocked from process, throughput, quality, and cost claims.",
      "gateHash": "sha256-67744ee0ca9038f1fcf83232c50eaa5466b8da24b4e43744bb75fcc0dc0d8609"
    },
    {
      "id": "evidence-gap-priority",
      "label": "Evidence gap priority ledger",
      "owner": "Product/science operations",
      "status": "pass",
      "evidence": {
        "ledgerHash": "sha256-0d96cc2ff9254f569ef8adbc51ba340f18dd55f15b5a02ce9adecdc6291e17a7",
        "gapCount": 36,
        "p0GapCount": 3,
        "topGapId": "gap-runtime-orekit-propagation-v1",
        "topGapScore": 78
      },
      "requiredProof": "The platform exposes a ranked closure backlog for source, runtime, economics, resource, traceability, and release evidence gaps.",
      "nextAction": "Work the P0-critical-path gaps in priority order; do not treat gap priority as evidence resolution.",
      "blocker": null,
      "gateHash": "sha256-e5e3d50265b42743f740b86503f4bfcc5549cbef36ca2969a38ba3e09518ad15"
    },
    {
      "id": "promotion-closure-ledger",
      "label": "Promotion closure ledger",
      "owner": "Product/science operations",
      "status": "pass",
      "evidence": {
        "ledgerHash": "sha256-d14fdc5117888b18cc4aaf6eabc8c09785595638de06e3cabcdd8cc0f8421f1c",
        "planCount": 5,
        "blockedClosurePlanCount": 3,
        "partialClosurePlanCount": 2,
        "readyForCustomerClaimCount": 0
      },
      "requiredProof": "Every blocked local science/resource/economics/materials promotion gate has an executable closure plan with source payloads, runtime artifacts, acceptance criteria, commands, and hash-backed next actions.",
      "nextAction": "Work the closure sequence without changing promotion status until source/runtime/reviewer evidence exists.",
      "blocker": null,
      "gateHash": "sha256-efb9cefcf31d62126db35bbd2d6dc557d3e1965d4f2dfc54b9dbdeac04075fb2"
    },
    {
      "id": "research-package-approval",
      "label": "Research package approval",
      "owner": "Product/review",
      "status": "blocked",
      "evidence": {
        "manifestHash": "sha256-acb877a48f3c3f16951cd0ffc3244b627c4fce0084e6eff9ca8a11a0fc37b9fb",
        "packageCount": 3,
        "blockedPackageCount": 3,
        "customerContractCount": 3,
        "blockedCustomerContractCount": 3,
        "commercialUseAllowed": false
      },
      "requiredProof": "At least one package has no blocked workspace/package/review gates and its customer readiness contract allows commercial use.",
      "nextAction": "Clear customer readiness contract blockers or keep packages explicitly beta-blocked.",
      "blocker": "All customer-facing research packages remain beta-blocked and commercial-use contracts are not clear.",
      "gateHash": "sha256-8dc2fbcac5fbb32800d773cd3f37c65e7b746a6cef2396b3ed803fbd653270fa"
    },
    {
      "id": "workspace-review-gates",
      "label": "Workspace review gates",
      "owner": "Research operations",
      "status": "blocked",
      "evidence": {
        "ledgerHash": "sha256-06be4865541ea0844d8c870d423cee2f284e13b32cb3ae611d3f3d4278940755",
        "workspaceCount": 3,
        "blockedWorkspaceCount": 3
      },
      "requiredProof": "Workspace source, claims, sidecar, and package gates are not blocked.",
      "nextAction": "Resolve blocked workspace gates before customer delivery.",
      "blocker": "All research workspaces still have at least one blocked review gate.",
      "gateHash": "sha256-81d6b5f5634da3028d37bda9bfa4a8418b11537e8f7fde90823a621c443ad27f"
    },
    {
      "id": "ui-fidelity-owner-approval",
      "label": "UI fidelity owner approval",
      "owner": "Product design / owner",
      "status": "human-review-pending",
      "evidence": {
        "ledgerHash": "sha256-857d823d3c191fe56b18c0fbf5c3c1fdffa61d86ed2ca03009a76bb5113f1e58",
        "requiredPageCount": 6,
        "referenceImageCount": 6,
        "renderedCaptureCount": 6,
        "automatedEvidenceCompleteCount": 6,
        "approvalPacketHash": "sha256-a9ebbc25e00bd64e0c64d0dee15a0a7d2e2241270ff75c11ba09c6c81568bdb6",
        "approvalPacketPageCount": 6,
        "reviewHtmlPath": "public/ui-fidelity-review/index.html",
        "ownerApprovalAllowed": false,
        "requiredPages": [
          "Command Overview",
          "Scenario Compare",
          "Solar Clock",
          "Body Ledger",
          "Process Lab",
          "Claims Register"
        ]
      },
      "requiredProof": "Owner-approved side-by-side screenshots against the six accepted mockups.",
      "nextAction": "Run screenshot mismatch ledger and record owner approval.",
      "blocker": "Exact mockup fidelity approval is not recorded.",
      "gateHash": "sha256-b422135113500bb848a26000351aa0551516cc28ba293b43092bc4ff56a8cf33"
    },
    {
      "id": "cloudflare-access-owner-approval",
      "label": "Cloudflare Access owner approval",
      "owner": "Release engineering",
      "status": "human-review-pending",
      "evidence": {
        "requiredHostname": "interstellarmanufacturing.sovereignsystemsagi.com"
      },
      "requiredProof": "Owner/reviewer browser session reaches the gated app and anonymous browser receives Access challenge.",
      "nextAction": "Record owner/reviewer browser approval evidence after Access login.",
      "blocker": "Owner browser approval evidence is not recorded in this repo.",
      "gateHash": "sha256-51282edd965870e3ae31b422b1da1587abf343b4ab2f38fb170c4f28730250ca"
    },
    {
      "id": "ci-secrets-deploy-proof",
      "label": "CI secrets deploy proof",
      "owner": "Release engineering",
      "status": "external-proof-pending",
      "evidence": {
        "deployWorkflowExpected": ".github/workflows/deploy.yml"
      },
      "requiredProof": "A remote CI run from a release branch/main with Cloudflare secrets deploys the exact artifact.",
      "nextAction": "Run GitHub Actions deployment with configured Cloudflare secrets.",
      "blocker": "No remote/secrets-backed CI deploy receipt is attached.",
      "gateHash": "sha256-20eb7b2355a9c248664bc765af1a8b4b420ebea54ee331670657fa48ee96e177"
    },
    {
      "id": "alert-webhook-recovery-proof",
      "label": "Alert webhook and recovery proof",
      "owner": "Cloudflare/DNS",
      "status": "external-proof-pending",
      "evidence": {
        "monitorRequired": "Cloudflare Worker Cron + webhook/email relay"
      },
      "requiredProof": "Two forced monitor failures emit one alert, then restored target emits one recovery alert.",
      "nextAction": "Attach a real webhook/email relay and run the forced failure/recovery proof.",
      "blocker": "Alert webhook/recovery path is not verified.",
      "gateHash": "sha256-01899c59e6ec3ea6f2ba918c6c6c4d474568778ea9af287534ee64e5b8c6ec87"
    }
  ],
  "blockedSummary": [
    {
      "id": "source-use-rights-review",
      "status": "blocked",
      "blocker": "Source-use rights remain blocked for customer/commercial use and raw payload redistribution.",
      "nextAction": "Capture source-specific terms/license artifacts and reviewer approvals before customer/commercial use."
    },
    {
      "id": "runtime-sidecar-promotion",
      "status": "partial",
      "blocker": "3 sidecar contract(s) still lack promoted runtime artifacts.",
      "nextAction": "Start with SPICE GF event windows or Orekit propagation, then cross-check with GMAT/Tudat."
    },
    {
      "id": "model-validation-protocols",
      "status": "partial",
      "blocker": "Ephemeris geometry and contact/event-window validation: Capability blocker: Runtime sidecar validation blocked: spice-gf-event-window-v1 Small-body orbit, close-approach, and resource-candidate validation: Runtime sidecar artifact not promoted: orekit-propagation-v1 Trajectory, transfer, and logistics cross-tool validation: Runtime sidecar artifact not promoted: orekit-propagation-v1",
      "nextAction": "Resolve model-validation protocol blockers by promoting required source payloads and runtime sidecar artifacts."
    },
    {
      "id": "resource-candidate-promotion",
      "status": "blocked",
      "blocker": "Asteroid candidates have geometry-screen evidence only; candidate source custody, resource composition, and customer-use gates remain blocked.",
      "nextAction": "Promote candidate-specific source work-order intake reports, then attach taxonomy/spectra/mission evidence and source-use clearance before resource promotion."
    },
    {
      "id": "economics-promotion",
      "status": "blocked",
      "blocker": "Economics records are still blocked from commercial economics claims.",
      "nextAction": "Promote dated launch, delivery, capex, opex, market, and award records through source intake."
    },
    {
      "id": "materials-process-promotion",
      "status": "blocked",
      "blocker": "Materials/process records are still blocked from process, throughput, quality, and cost claims.",
      "nextAction": "Promote reviewed NIST/Materials Project/PDS material records and runtime process artifacts before using process claims commercially."
    },
    {
      "id": "research-package-approval",
      "status": "blocked",
      "blocker": "All customer-facing research packages remain beta-blocked and commercial-use contracts are not clear.",
      "nextAction": "Clear customer readiness contract blockers or keep packages explicitly beta-blocked."
    },
    {
      "id": "workspace-review-gates",
      "status": "blocked",
      "blocker": "All research workspaces still have at least one blocked review gate.",
      "nextAction": "Resolve blocked workspace gates before customer delivery."
    },
    {
      "id": "ui-fidelity-owner-approval",
      "status": "human-review-pending",
      "blocker": "Exact mockup fidelity approval is not recorded.",
      "nextAction": "Run screenshot mismatch ledger and record owner approval."
    },
    {
      "id": "cloudflare-access-owner-approval",
      "status": "human-review-pending",
      "blocker": "Owner browser approval evidence is not recorded in this repo.",
      "nextAction": "Record owner/reviewer browser approval evidence after Access login."
    },
    {
      "id": "ci-secrets-deploy-proof",
      "status": "external-proof-pending",
      "blocker": "No remote/secrets-backed CI deploy receipt is attached.",
      "nextAction": "Run GitHub Actions deployment with configured Cloudflare secrets."
    },
    {
      "id": "alert-webhook-recovery-proof",
      "status": "external-proof-pending",
      "blocker": "Alert webhook/recovery path is not verified.",
      "nextAction": "Attach a real webhook/email relay and run the forced failure/recovery proof."
    }
  ],
  "releaseRule": "Do not mark public beta complete until releaseAllowed is true or every non-pass gate is explicitly accepted as a scoped beta limitation by the owner.",
  "ledgerHash": "sha256-c199aaa636095440da451e434bb3e2605abba466020771855b8292316c3df895"
}
;
